const highlights = [
    {
        title: 'All-in-One Platform',
        desc: 'Every service under one roof – no third-party hassle.',
    },
    {
        title: 'Student Friendly Offers',
        desc: 'Exclusive discounts and services for verified students.',
    },
    {
        title: 'Advertisement Support',
        desc: 'Boost your visibility with our targeted ad placements.',
    },
];

const WhyChooseUs = () => (
    <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
            <h2
                className="text-3xl font-bold mb-10"
                data-aos="fade-up"
                data-aos-duration="800"
            >Why Choose Us?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {highlights.map((item, i) => (
                    <div
                        key={i}
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay={i * 150}
                        className="bg-gray-100 p-6 rounded-lg shadow"
                    >
                        <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                        <p className="text-gray-600">{item.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default WhyChooseUs;
